import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { getFormValues } from 'redux-form'
// hooks
import { useCurrentTable } from 'hooks/risks'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
// constants
import { Forms } from 'constants/forms'
// utils
import { buildGetTree, Level } from '../GroupedColumn/utils'

export const useGroupingTree = (parentId: string, subFieldLinkId?: string): Level => {
  const { groupingMap } = useCurrentTable()

  const { form } = React.useContext(RiskViewContext)

  const formName = form ?? Forms.RISK_TEMPLATE_FORM
  const selector = React.useMemo(() => getFormValues(formName), [formName])

  const formValues = useSelector(selector)

  const { getTree } = React.useMemo(() => buildGetTree(formValues, groupingMap), [formValues, groupingMap])

  return getTree(parentId, subFieldLinkId)
}
